export default {
	computed: {
		getLocale() {
			return this.$i18n.locale.toUpperCase();
		},
	},
};
